<template>
  <div>
    <b-card
      v-if="!isBarCodeStep"
      :title="`${$t('common.create')} ${$t('warehouse.stock-in')}`"
    >
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <CategoryModal
              :isPharmacy="$route.name.includes('pharmacy') ? true : false"
              @category="assignCategory"
            />
          </b-col>
          <b-col lg="4">
            <AutoComplete
              :label="$t('warehouse.one-item')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-item'
              )}`"
              v-model="stockinForm.item_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="item"
              text-title="name"
              :otherQuery="otherQuery"
            />
          </b-col>
          <b-col lg="4">
            <AutoComplete
              :label="$t('warehouse.one-warehouse')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-warehouse'
              )}`"
              v-model="stockinForm.warehouse_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="warehouse"
              text-title="name"
              :otherQuery="`filter[type]=${
                $route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
            />
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('warehouse.batch-no')" label-for="batch">
              <b-form-input
                id="batch"
                v-model="stockinForm.batch_no"
                :placeholder="$t('warehouse.batch-no')"
              />
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group :label="$t('warehouse.exp-date')" label-for="date">
              <datepicker
                v-model="stockinForm.expiry_date"
                :calendar-button="true"
                :clear-button="true"
                format="YYYY-MM-DD"
                :bootstrap-styling="true"
                class="datebtn2"
                :disabled-dates="{
                  to: new Date(new Date().setDate(new Date().getDate() - 1)),
                }"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group
              :label="$t('warehouse.quantity')"
              label-for="Quantity"
            >
              <b-form-input
                type="number"
                id="Quantity"
                v-model="stockinForm.quantity"
                :placeholder="$t('warehouse.quantity')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group
              :label="$t('warehouse.purchase-price')"
              label-for="Price"
            >
              <b-form-input
                type="number"
                id="Price"
                v-model="stockinForm.purchase_price"
                :placeholder="$t('warehouse.purchase-price')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('warehouse.sell-price')" label-for="Price">
              <b-form-input
                type="number"
                id="Price"
                v-model="stockinForm.sell_price"
                :placeholder="$t('warehouse.sell-price')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4" v-if="isPharmacy">
            <AutoComplete
              :label="$t('pharmacy.drug_store')"
              :placeholder="`${$t('common.select')} ${$t(
                'pharmacy.drug_store'
              )}`"
              v-model="stockinForm.drug_store_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="drugStore"
              text-title="name"
            />
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            class="mt-2"
            ref="myButton"
            variant="primary"
            @click="showScanBarCodeStep"
          >
            {{ $t("common.add") }} {{ $t("common.to") }}
            {{ $t("warehouse.stockins") }}
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <b-card v-if="isBarCodeStep">
      <ScanBarcode @barcode="addToStockIns($event)" />
    </b-card>
    <b-card :title="$t('warehouse.item')">
      <b-table
        :items="stockins"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="stockins.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
const ScanBarcode = () => import("@/views/warehouse/ScanBarcode.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    BCardText,
    CategoryModal,
    ScanBarcode,
  },
  data() {
    return {
      categoryFilter: {
        name: "",
        id: "",
      },
      isBarCodeStep: false,
      loading: true,
      stockinForm: {
        type: this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital",
        item_id: "",
        warehouse_id: "",
        barcode: "",
        batch_no: "",
        expiry_date: "",
        quantity: "",
        purchase_price: "",
        sell_price: "",
      },

      tableColumns: [
        { key: "item_id.name", label: this.$t("common.name"), sortable: true },
        {
          key: "warehouse_id.name",
          label: this.$t("warehouse.one-warehouse"),
          sortable: true,
        },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "purchase_price",
          label: this.$t("warehouse.purchase-price"),
          sortable: true,
        },
        {
          key: "sell_price",
          label: this.$t("warehouse.sell-price"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      stockins: [],
      params: {
        form: {},
        path: "",
      },
    };
  },

  computed: {
    otherQuery() {
      if (this.categoryFilter.id) {
        return `&filter[category_id]=${this.categoryFilter.id}&filter[type]=${
          this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
        }`;
      } else {
        return `&filter[type]=${
          this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
        }`;
      }
    },
    isPharmacy() {
      return this.$route.name.includes("pharmacy");
    },
  },
  methods: {
    assignCategory(v) {
      this.stockinForm.item_id = null;
      this.categoryFilter = v;
    },
    showScanBarCodeStep() {
      this.isBarCodeStep = true;
    },
    addToStockIns(barcode) {
      this.stockinForm.expiry_date = this.formatExpDate(
        this.stockinForm.expiry_date
      );
      this.stockinForm.barcode = barcode;
      this.stockins.push(this.stockinForm);
      this.stockinForm = {
        type: this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital",
        item_id: "",
        barcode: "",
        warehouse_id: "",
        batch_no: "",
        expiry_date: "",
        quantity: "",
        purchase_price: "",
        sell_price: "",
      };
      this.isBarCodeStep = false;
    },
    removeItem(item) {
      this.stockins = this.stockins.filter((stockin) => stockin !== item);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    submitItem() {
      this.stockins = this.stockins.map((stock) => ({
        ...stock,
        item_id: stock.item_id.id,
        warehouse_id: stock.warehouse_id.id,
      }));

      (this.params.form = { stockins: this.stockins }),
        (this.params.path = `/stockin`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.$router.push({
              name: `${
                this.$route.name.includes("pharmacy")
                  ? "pharmacy-stockin"
                  : "stockin"
              }`,
            });

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Created",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
